<template>
  <div class="help-body">
    <h2>Passwords and Sign in</h2>
    <ul class="help-list">
      <li>
        <h3 @click="setInfoClicked(0)"><span :class="upOrDown(0)"></span>I forgot my username</h3>

        <div class="reveal-info">
          <p v-show="isInfoClicked(0)">
            Your username can be emailed to you when you enter the email address you use to receive
            notifications.
            <br />
            <router-link to="/help/forgot-username">Forgot your username</router-link>
          </p>
        </div>
      </li>
      <li>
        <h3 @click="setInfoClicked(1)"><span :class="upOrDown(1)"></span>I forgot my password</h3>

        <div class="reveal-info">
          <p v-show="isInfoClicked(1)">
            We will send instructions on how to reset your password to the email address associated
            with your account.
            <br />
            <router-link to="/help/forgot-password">Forgot your password</router-link>
          </p>
        </div>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>
import { AppActions } from '@/app/app.keys';

export default {
  data() {
    return {
      selectedInfo: {
        0: false,
        1: false
      }
    };
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('app.help.title'));
  },
  methods: {
    isInfoClicked(index) {
      return this.selectedInfo[index];
    },
    upOrDown(index) {
      return this.selectedInfo[index] ? 'down' : 'right';
    },
    setInfoClicked(index) {
      this.selectedInfo[index] = !this.selectedInfo[index];
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.help-body {
  display: flex;
  flex-direction: column;
  padding: 60px;
  background-color: $white;
  .help-list {
    list-style: none;
    li {
      &:not(:last-of-type) {
        border-bottom: 1px solid $row-border;
      }
    }
    .right {
      display: inline-block;
      width: 25px;
      //margin-right: 8px;
      &::before {
        content: '▶';
      }
    }
    .down {
      display: inline-block;
      width: 25px;
      &::before {
        content: '▼';
      }
    }
  }
}
</style>
